import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { registerLocaleData } from '@angular/common';
import zh from '@angular/common/locales/zh';
registerLocaleData(zh);

import { SharedModule } from './shared/shared.module';
import { RoutesModule } from './routes/routes.module';
import { AppComponent } from './app.component';
import { BootService } from './services/boot.service';
import { HttpService } from './services/http.service';
import { SessionService } from './services/session.service';
import { RoutesRouting } from './routes/routes.routing';

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    RoutesModule,
    RoutesRouting
  ],
  declarations: [
    AppComponent
  ],
  providers: [
    HttpService,
    BootService,
    SessionService,
    { provide: APP_INITIALIZER, useFactory: (bootService: BootService) => { return () => bootService.boot(); }, deps: [BootService], multi: true }
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule { }
